import { formatters } from 'components/hierarchical-report/Layout'

import { COLLECTION_METRICS, getMetricDisplayLabel } from './collectionMetrics'

const percent = cell => formatters.percent(cell)
const percentOrDash = cell => cell === 0 ? '--' : formatters.percent(cell)
const numberParent = key => formatters.parentPercent(formatters.number, key)
const moneyParent = key => formatters.parentPercent(formatters.money(), key)

export const MONEY_KEYS = new Set([
  'balance', 'credits', 'cost', 'min', 'max', 'avg',
  'rps', 'rpus', 'rpu', 'rpi', 'revenue', 'margin',
  'cps', 'cpu', 'cpc', 'rpc', 'cpfc', 'rpfc',
  'currentBalance',
])

const METRIC_COLUMN_DEFINITIONS = {
  total: {
    text: 'Page Impressions',
    formatter: numberParent('total'),
    customSort: true,
  },
  uniqPathSession: {
    text: 'Path Session Impressions',
    formatter: numberParent('uniqPathSession'),
    customSort: true,
  },
  uniqUser: {
    text: 'Unique Users',
    formatter: numberParent('uniqUser'),
    customSort: true,
  },
  uniqUserSession: {
    text: 'User Sessions',
    formatter: numberParent('uniqUserSession'),
    customSort: true,
  },
  uniqPathSessionPC: {
    text: 'Path Session Impressions (%)',
    formatter: percent,
    customSort: true,
  },
  completed: {
    text: 'Page Completed',
    formatter: numberParent('completed'),
    customSort: true,
  },
  completedPC: {
    text: 'Page Completed (%)',
    formatter: percent,
    customSort: true,
  },
  notCompleted: {
    text: 'Page Not Completed',
    formatter: numberParent('notCompleted'),
    customSort: true,
  },
  notCompletedPC: {
    text: 'Page Not Completed (%)',
    formatter: percent,
    customSort: true,
  },
  rpi: {
    text: 'RPI',
    formatter: moneyParent('rpi'),
    customSort: true,
  },
  rps: {
    text: 'RPS',
    formatter: moneyParent('rps'),
    customSort: true,
  },
  rpus: {
    text: 'RPUS',
    formatter: moneyParent('rpus'),
    customSort: true,
  },
  rpu: {
    text: 'RPU',
    formatter: moneyParent('rpu'),
    customSort: true,
  },
  revenue: {
    text: 'Revenue',
    formatter: moneyParent('revenue'),
    customSort: true,
  },
  fraud: {
    text: 'Fraud Impressions',
    formatter: numberParent('fraud'),
    customSort: true,
  },
  fraudPC: {
    text: 'Fraud Impressions %',
    formatter: percent,
    customSort: true,
  },
  notFraud: {
    text: 'Not Fraud Impressions',
    formatter: numberParent('notFraud'),
    customSort: true,
  },
  notFraudPC: {
    text: 'Not Fraud Impressions %',
    formatter: percent,
    customSort: true,
  },
  uniqueReg: {
    text: 'Uniq. Reg.',
    formatter: numberParent('uniqueReg'),
    customSort: true,
  },
  uniqueRegPC: {
    text: 'Uniq. Reg. (%)',
    formatter: percent,
    customSort: true,
  },
  uniqUserPC: {
    text: 'Uniq. Users (%)',
    formatter: percent,
    customSort: true,
  },
  converted: {
    text: 'Conversion',
    formatter: numberParent('converted'),
    customSort: true,
  },
  convertedTrue: {
    text: 'Form Converted',
    formatter: numberParent('convertedTrue'),
    customSort: true,
  },
  convertedPC: {
    text: 'Conversion (%)',
    formatter: percent,
    customSort: true,
  },
  convertedTruePC: {
    text: 'Form Converted (%)',
    formatter: percent,
    customSort: true,
  },
  scrub: {
    text: 'Scrub',
    formatter: numberParent('scrub'),
    customSort: true,
  },
  scrubPC: {
    text: 'Scrub (%)',
    formatter: (cell, { converted, scrub }) => formatters.percent(cell, scrub + converted),
    customSort: true,
  },
  duplicated: {
    text: 'Duplicated',
    formatter: numberParent('duplicated'),
    customSort: true,
  },
  duplicatedPC: {
    text: 'Duplicated (%)',
    formatter: percent,
    customSort: true,
  },
  duplicatedData: {
    text: 'Duplicated Data',
    formatter: numberParent('duplicatedData'),
    customSort: true,
  },
  duplicatedDataPC: {
    text: 'Duplicated Data (%)',
    formatter: percent,
    customSort: true,
  },
  duplicatedClick: {
    text: 'Duplicated Click',
    formatter: numberParent('duplicatedClick'),
    customSort: true,
  },
  duplicatedClickPC: {
    text: 'Duplicated Click (%)',
    formatter: percent,
    customSort: true,
  },
  tcpaconsent: {
    text: 'TCPA consent',
    formatter: numberParent('tcpaconsent'),
    customSort: true,
  },
  tcpaconsentPC: {
    text: 'TCPA consent (%)',
    formatter: percent,
    customSort: true,
  },
  fraudConversion: {
    text: 'Conv. Type is Fraud',
    formatter: numberParent('fraudConversion'),
    customSort: true,
  },
  fraudCheckTrue: {
    text: 'Is fraud',
    formatter: numberParent('fraudCheckTrue'),
    customSort: true,
  },
  fraudCheckFalse: {
    text: 'Is Not fraud',
    formatter: numberParent('fraudCheckFalse'),
    customSort: true,
  },
  fraudNotCheck: {
    text: 'Fraud not verified',
    formatter: numberParent('fraudNotCheck'),
    customSort: true,
  },
  awaitingFraudCheck: {
    text: 'Awaiting Fraud Verification',
    formatter: numberParent('awaitingFraudCheck'),
    customSort: true,
  },
  fraudConversionPC: {
    text: 'Conv. Type is Fraud (%)',
    formatter: percent,
    customSort: true,
  },
  fraudCheckTruePC: {
    text: 'Is fraud (%)',
    formatter: percent,
    customSort: true,
  },
  fraudCheckFalsePC: {
    text: 'Is not fraud (%)',
    formatter: percent,
    customSort: true,
  },
  fraudNotCheckPC: {
    text: 'Fraud not verified (%)',
    formatter: percent,
    customSort: true,
  },
  awaitingFraudCheckPC: {
    text: 'Awaiting Fraud Verification (%)',
    formatter: percent,
    customSort: true,
  },
  fraudProjectedPC: {
    text: 'Projected fraud (%)',
    formatter: percent,
    customSort: true,
  },
  cost: {
    text: 'Cost ($)',
    formatter: moneyParent('cost'),
    customSort: true,
  },
  margin: {
    text: 'Margin ($)',
    formatter: formatters.parentPercent(
      cell => formatters.colorize(formatters.money()(cell), cell),
      'revenue',
    ),
    customSort: true,
  },
  marginPC: {
    text: 'Margin (%)',
    formatter: cell => formatters.colorize(formatters.percent(cell), cell),
    customSort: true,
  },
  cps: {
    text: 'CPS',
    formatter: formatters.money(),
    customSort: true,
  },
  cpu: {
    text: 'CPU',
    formatter: formatters.money(),
    customSort: true,
  },
  cpc: {
    text: 'CPC',
    formatter: formatters.money(),
    customSort: true,
  },
  rpc: {
    text: 'RPC',
    formatter: formatters.money(),
    customSort: true,
  },
  cpfc: {
    text: 'CPFC',
    formatter: formatters.money(),
    customSort: true,
  },
  rpfc: {
    text: 'RPFC',
    formatter: formatters.money(),
    customSort: true,
  },
  uniqSession: {
    text: 'Unique Sessions',
    formatter: numberParent('uniqSession'),
    customSort: false,
  },
  rulesSuccessful: {
    text: 'Rules accepted',
    formatter: numberParent('rulesSuccessful'),
    customSort: true,
  },
  rulesSuccessfulPC: {
    text: 'Rules accepted (%)',
    formatter: percentOrDash,
    customSort: true,
  },
  prepingSuccessful: {
    text: 'Preping accepted',
    formatter: numberParent('prepingSuccessful'),
    customSort: true,
  },
  prepingSuccessfulPC: {
    text: 'Preping accepted (%)',
    formatter: percentOrDash,
    customSort: true,
  },
  prepingRejected: {
    text: 'Preping rejected',
    formatter: numberParent('prepingRejected'),
    customSort: true,
  },
  prepingRejectedPC: {
    text: 'Preping rejected (%)',
    formatter: percentOrDash,
    customSort: true,
  },
  successCalls: {
    text: 'Success',
    formatter: numberParent('successCalls'),
    customSort: true,
  },
  successCallsPC: {
    text: 'Success Calls (%)',
    formatter: percentOrDash,
    customSort: true,
  },
  medianLatency: {
    text: 'Median Latency (ms)',
    formatter: cell => !cell ? '--' : formatters.number(cell),
    customSort: true,
  },
  failedCalls: {
    text: 'Failed calls',
    formatter: numberParent('failedCalls'),
    customSort: true,
  },
  failedCallsPC: {
    text: 'Failed Calls (%)',
    formatter: percentOrDash,
    customSort: true,
  },
  currentBalance: {
    text: 'Current Balance',
    formatter: moneyParent('currentBalance'),
    customSort: true,
    sortValue: row => row.currentBalance || 0,
  },
  credits: {
    text: 'Credits',
    formatter: moneyParent('credits'),
    customSort: true,
  },
  balance: {
    text: 'Balance',
    formatter: moneyParent('balance'),
    customSort: true,
  },
  min: {
    text: 'Min',
    formatter: moneyParent('min'),
    customSort: true,
  },
  max: {
    text: 'Max',
    formatter: moneyParent('max'),
    customSort: true,
  },
  avg: {
    text: 'Average',
    formatter: moneyParent('avg'),
    customSort: true,
  },
  conversions: {
    text: 'Conversions',
    formatter: (cell, row) => formatters.number(cell || 0, row),
    customSort: true,
    sortValue: row => row.conversions || 0,
  },
}

function getMetricLabel(key) {
  for (const metrics of Object.values(COLLECTION_METRICS)) {
    const metric = metrics.find(entry => entry.key === key)
    if (metric) return metric.label
  }

  return formatters.groupsText(key)
}

function getDefaultMetricFormatter(key) {
  if (key.endsWith('PC')) return percent

  if (key === 'margin') {
    return formatters.parentPercent(
      cell => formatters.colorize(formatters.money()(cell), cell),
      'revenue',
    )
  }

  if (MONEY_KEYS.has(key)) return moneyParent(key)

  return numberParent(key)
}

export function buildMetricColumn(key, collection) {
  const definition = METRIC_COLUMN_DEFINITIONS[key]

  return {
    dataField: key,
    text: getMetricDisplayLabel(collection, { key }) || getMetricLabel(key),
    customSort: definition?.customSort ?? true,
    sortValue: definition?.sortValue || (row => row[key]),
    formatter: definition?.formatter || getDefaultMetricFormatter(key),
  }
}
